import LogRocket from "logrocket";

export const initializeLogRocketUser = (uid: string, mobile: string) => {
    LogRocket.identify(uid, {email: mobile})
}